import { Check } from '@suranceadmin/icons/native';
import React from 'react';
import { StyleSheet } from 'react-native';
import colors from '../../styles/colors';
import Card from '../Card';
import Text, { TextType } from '../Typography/Text';

const ListItem = _ref => {
  let {
    onPress,
    style,
    title,
    isSelected,
    isShadowDisplayed = false,
    iconColor = colors.icon.link,
    icon = /*#__PURE__*/React.createElement(Check, {
      color: iconColor
    })
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    onPress: onPress,
    isShadowDisplayed: isShadowDisplayed,
    style: [styles.view, style]
  }, /*#__PURE__*/React.createElement(Text, {
    type: TextType.Body
  }, title), isSelected && icon);
};

const styles = StyleSheet.create({
  view: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 40
  }
});
export default ListItem;
//# sourceMappingURL=index.js.map